module.exports = __webpack_public_path__ + "static/media/alphabetT.9543aaf2.svg";